import * as React from 'react';
import { withTranslation } from 'react-i18next';

type State = {
  hasError: boolean;
};

type ErrorBoundaryBaseProps = {
  children?: React.ReactNode;
};

type ErrorBoundaryWithTranslation = ErrorBoundaryBaseProps & {
  t: (key: string) => string;
};

class ErrorBoundaryBase extends React.Component<ErrorBoundaryBaseProps, State> {
  constructor(props: ErrorBoundaryBaseProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      const { t } = this.props as ErrorBoundaryWithTranslation;
      return <h1>{t ? t('pages.errorBoundary.message') : 'An error occurred'}</h1>;
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundaryBase) as React.ComponentType<ErrorBoundaryBaseProps>;
